var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.890137,
    width: 30,
    height: 30,
    rx: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_2668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0031 12.2965C13.0156 12.2965 11.4125 13.8996 11.4125 15.8871C11.4125 17.8746 13.0156 19.4777 15.0031 19.4777C16.9906 19.4777 18.5937 17.8746 18.5937 15.8871C18.5937 13.8996 16.9906 12.2965 15.0031 12.2965ZM15.0031 18.2215C13.7187 18.2215 12.6687 17.1746 12.6687 15.8871C12.6687 14.5996 13.7156 13.5527 15.0031 13.5527C16.2906 13.5527 17.3375 14.5996 17.3375 15.8871C17.3375 17.1746 16.2875 18.2215 15.0031 18.2215ZM19.5781 12.1496C19.5781 12.6152 19.2031 12.9871 18.7406 12.9871C18.275 12.9871 17.9031 12.6121 17.9031 12.1496C17.9031 11.6871 18.2781 11.3121 18.7406 11.3121C19.2031 11.3121 19.5781 11.6871 19.5781 12.1496ZM21.9562 12.9996C21.9031 11.8777 21.6469 10.884 20.825 10.0652C20.0062 9.24648 19.0125 8.99023 17.8906 8.93398C16.7344 8.86836 13.2687 8.86836 12.1125 8.93398C10.9937 8.98711 9.99999 9.24336 9.17812 10.0621C8.35624 10.8809 8.10312 11.8746 8.04687 12.9965C7.98124 14.1527 7.98124 17.6184 8.04687 18.7746C8.09999 19.8965 8.35624 20.8902 9.17812 21.709C9.99999 22.5277 10.9906 22.784 12.1125 22.8402C13.2687 22.9059 16.7344 22.9059 17.8906 22.8402C19.0125 22.7871 20.0062 22.5309 20.825 21.709C21.6437 20.8902 21.9 19.8965 21.9562 18.7746C22.0219 17.6184 22.0219 14.1559 21.9562 12.9996ZM20.4625 20.0152C20.2187 20.6277 19.7469 21.0996 19.1312 21.3465C18.2094 21.7121 16.0219 21.6277 15.0031 21.6277C13.9844 21.6277 11.7937 21.709 10.875 21.3465C10.2625 21.1027 9.79062 20.6309 9.54374 20.0152C9.17812 19.0934 9.26249 16.9059 9.26249 15.8871C9.26249 14.8684 9.18124 12.6777 9.54374 11.759C9.78749 11.1465 10.2594 10.6746 10.875 10.4277C11.7969 10.0621 13.9844 10.1465 15.0031 10.1465C16.0219 10.1465 18.2125 10.0652 19.1312 10.4277C19.7437 10.6715 20.2156 11.1434 20.4625 11.759C20.8281 12.6809 20.7437 14.8684 20.7437 15.8871C20.7437 16.9059 20.8281 19.0965 20.4625 20.0152Z",
    fill: "#25282B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_2668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7.89014)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF5);
export default __webpack_public_path__ + "static/media/f5.45d1c066e8f8a3c6ac1bd1b7c2f371bc.svg";
export { ForwardRef as ReactComponent };